export default __webpack_public_path__ + "static/media/term-condition-cn.7bc42a9f.svg";